import React, { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUserProfileImage } from '../../redux/slice/userCameraProfile';
import { sfcUserDetails } from '../../redux/slice/sfcUserBasicInfo';
import { setShowUnsavedChangesPopup } from '../../redux/slice/expenseGenerator';
// images
import uploadBillWhiteIcon from '/assets/images/uploadBillWhiteIcon.png';
import defaultUserIcon from '/assets/images/defaultUserIcon.png';
import STPFC from '../../assets/icons/STPFC.png';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import ExpenseApproval from '../../assets/icons/ExpenseApproval.png';
import report from '/assets/images/report.png';
import stpfcReport from '/assets/images/stpfcReport.png'
import { getScreenPermission } from '../../utils/permissions';

const Sidebar = ({ isOpen, toggleDrawer, config = [] }) => {
  const drawerRef = useRef(null);
  const dispatch = useDispatch();
  const { data: image } = useSelector((state) => state.userProfileImage);
  const { isSaved } = useSelector((state) => state.expenseGenerator);
  const location = useLocation();
  const permissions = getScreenPermission();

  // Close sidebar when clicking outside
  const handleClickOutside = (event) => {
    if (
      isOpen &&
      drawerRef.current &&
      !drawerRef.current.contains(event.target)
    ) {
      toggleDrawer(false);
    }
  };

  const area = JSON.parse(localStorage.getItem('userData'))?.areaRange;

  useEffect(() => {
    dispatch(sfcUserDetails());
  }, [dispatch]);

  const userData = JSON.parse(localStorage.getItem('userData'));
  // const { isHospitalSurveyEnable } = JSON.parse(localStorage.getItem('userData'));

  useEffect(() => {
    dispatch(getUserProfileImage());
  }, [dispatch]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleSidebarNavigation = (event) => {
    const isExpenseCreationPage = location.pathname.startsWith('/expense-creation');
    if (isExpenseCreationPage && isSaved) {
      event.preventDefault();
      dispatch(setShowUnsavedChangesPopup(true));
      return;
    }
    toggleDrawer(false);
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" // Only shows backdrop on small and medium screens
          onClick={() => toggleDrawer(false)}
        ></div>
      )}

      <div
        ref={drawerRef}
        className={`fixed lg:static top-0 left-0 z-50 h-full transition-transform duration-300 lg:w-1/5 smAndMd:w-3/5 lg:bg-[#123C69] smAndMd:bg-white text-gray-400 overflow-y-auto lg:text-white
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
          lg:translate-x-0 flex flex-col justify-between`}
      >
        {/* User Information */}
        <div className="lg:pt-16">
          <Tooltip id="profile" className="!text-xs" />
          <Link
            to="/user"
            id="profile"
            className="block p-4"
            onClick={() => toggleDrawer(false)}
          >
            <div
              className="flex items-center"
              data-tooltip-id="profile"
              data-tooltip-content={'View Profile'}
              data-tooltip-place="bottom"
            >
              <img
                src={image?.imageBase64 || defaultUserIcon}
                alt="User"
                className="w-14 h-14 rounded-full"
              />
              <div className="ml-3">
                <p className="text-sm text-gray-400">
                  {userData?.employeeName || 'Unknown'}
                </p>
                {/* <p className="text-sm text-gray-400 lg:text-baseSm">
                  {userData?.companyId || 'Company ID'}
                </p> */}
                <p className="text-sm text-gray-400 ">
                  {userData?.companyName?.slice(0, 16) || 'Company Name'}
                </p>
              </div>
            </div>
          </Link>
        </div>

        {/* Navigation Links */}
        <nav className="flex-1  smAndMd:p-2">
          <ul>
            {config
              ?.filter(
              (item) => {
                if (item.path === '/setting' || item.path === '/logout') {
                  return false;
                }
                // Enable and Disable LeaveModule based on isHospitalSurveyEnable flag and LeaveApproval based on isHospitalSurveyEnable and visible only for the arearange other than 'T'
                if (item.path === '/LeaveModule' && userData?.isHospitalSurveyEnable) {
                  return false;
                }
                if (item.path === '/LeaveApproval' && !(userData?.isHospitalSurveyEnable == 0 && area !== 'T')
                ) {
                  return false;
                }
                if(!permissions?.[item.path]) {
                  return false;
                }
                return true;
              })

              ?.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item?.path}
                    onClick={handleSidebarNavigation}
                    className={`flex items-center lg:p-2 smAndMd:pt-2 lg:hover:bg-[#184C84] ${
                      location.pathname.startsWith(item.path)
                        ? 'lg:bg-[#184C84]  lg:text-white'
                        : ''
                    }`}
                  >
                    <img
                      src={item?.icon}
                      alt={item.name}
                      className="h-4 w-4 filter-gray lg:filter-white ml-2"
                    />
                    <span className="ml-3 lg:text-baseMd">{item?.name}</span>
                  </Link>
                </li>
              ))}

              {/* Upload Bills */}
            {permissions?.['/upload-bills'] ? <li className="hidden lg:block">
              <Link
                to="/upload-bills"
                id="Uploads"
                onClick={handleSidebarNavigation}
                className={`flex items-center p-2 lg:hover:bg-[#184C84] ${
                  location.pathname === '/upload-bills'
                    ? 'lg:bg-[#184C84] lg:text-white'
                    : ''
                }`}
              >
                <img
                  src={uploadBillWhiteIcon}
                  alt="expense-icon"
                  className="h-4 w-4 filter-gray lg:filter-white ml-2"
                />
                <span className="ml-3 lg:text-baseMd ">{'Upload Bills'}</span>
              </Link>
            </li> : null}


                {/* Expense Report */}
            {permissions?.['/expense-report'] ? area !== undefined && area !== 'Z' && (
              <li  className="lg:block smAndMd:-ml-2">
                <Link
                  to="/expense-report"
                  onClick={handleSidebarNavigation}
                  className={`flex items-center p-2 lg:hover:bg-[#184C84] ${
                    location.pathname === '/expense-report'
                      ? 'lg:bg-[#184C84] lg:text-white'
                      : ''
                  }`}
                >
                  <img
                    src={report}
                    alt="expense-icon"
                    className="h-4 w-4 filter-gray lg:filter-white ml-2"
                  />
                  <span className="ml-2 lg:text-baseMd">
                    {'Expense Report'}
                  </span>
                </Link>
              </li>
            ) : null}

            {/* STPFC Report */}
            {permissions?.['/stpfc-report'] ? area !== undefined && area !== 'Z' && (
              <li  className="lg:block smAndMd:-ml-2">
                <Link
                  to="/stpfc-report"
                  onClick={handleSidebarNavigation}
                  className={`flex items-center p-2 lg:hover:bg-[#184C84] ${
                    location.pathname === '/stpfc-report'
                      ? 'lg:bg-[#184C84] lg:text-white'
                      : ''
                  }`}
                >
                  <img
                    src={stpfcReport}
                    alt="expense-icon"
                    className="h-4 w-4 filter-gray lg:filter-white ml-2"
                  />
                  <span className="ml-2 lg:text-baseMd">
                    {'STPFC Report'}
                  </span>
                </Link>
              </li>
            ) : null}

            {/* STPFC Approval */}
            {permissions?.['/stpfc-approval'] ? area !== undefined && area !== 'T' && (
              <li id="stpfc" className="lg:block smAndMd:-ml-2">
                <Link
                  to="/stpfc-approval"
                  onClick={handleSidebarNavigation}
                  className={`flex items-center p-2 lg:hover:bg-[#184C84] ${
                    location.pathname === '/stpfc-approval'
                      ? 'lg:bg-[#184C84] lg:text-white'
                      : ''
                  }`}
                >
                  <img
                    src={STPFC}
                    alt="expense-icon"
                    className="h-4 w-4 filter-gray lg:filter-white ml-2"
                  />
                  <span className="ml-2 lg:text-baseMd">
                    {'STPFC Approval'}
                  </span>
                </Link>
              </li>
            ) : null}

            {/* Expense Approval */}
            {permissions?.['/expense-approval'] ? area !== undefined && area !== 'T' && (
              <li
                id="expenses"
                className="lg:block smAndMd:-ml-2 smAndMd:-mt-2"
              >
                <Link
                  to="/expense-approval"
                  onClick={handleSidebarNavigation}
                  className={`flex items-center p-2 lg:hover:bg-[#184C84] ${
                    location.pathname.startsWith('/expense-approval') ||
                    location.pathname.startsWith('/expense-details')
                      ? 'lg:bg-[#184C84] lg:text-white'
                      : ''
                  }`}
                >
                  <img
                    src={ExpenseApproval}
                    alt="expense-icon"
                    className="h-4 w-4 filter-gray lg:filter-white ml-2"
                  />
                  <span className="ml-2 lg:text-baseMd">
                    {'Expense Approval'}
                  </span>
                </Link>
              </li>
            ) : null}
          </ul>
        </nav>

        {/* Footer Links */}
        <div className="p-2">
          <ul className="flex justify-between">
            {config
              ?.filter(
                (item) => item.path === '/setting' || item.path === '/logout'
              )
              ?.map((item) => (
                <li key={item?.path}>
                  <Link
                    to={item?.path}
                    onClick={() => toggleDrawer(false)}
                    className={`flex items-center p-2 lg:hover:bg-[#184C84] ${
                      location.pathname === item.path
                        ? 'bg-[#184C84] text-white'
                        : ''
                    }`}
                  >
                    <img
                      src={item?.icon}
                      alt={item.name}
                      className="h-4 w-4 filter-gray lg:filter-white"
                    />
                  </Link>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
